import {
    InitDto,
    Link,
    MenuDto, ModeltypeBasicDto, ModelyearDto, ResourceListOfModeltypeBasicDto,
    ResourceListOfWorkflowDto,
    UserDto,
    WorkflowDto,
    MaintenanceDto,
    MaintenanceListDto
} from "../../services/Client";
import {AnyAction} from "redux";
import {IApplicationLink} from "../../data/IApplicationLink";
import {IUserSettings} from "../../data/IUserSettings";
import {Dispatch} from "react-redux";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import {Helpers} from "../reducers/Helpers";
import {ActionTypes} from "./ActionTypes";
import {ILocationTranslation} from "src/components/GeneralInterfaces";
import {IReduxState} from "../IReduxState";

const GeneralActions = {
    ReceiveBaseLinksAction(dto: MenuDto): AnyAction {
        return {type: ActionTypes.RECEIVE_BASE_LINKS, baseLinks: dto};
    },
    ReceiveInitDataAction(dto: InitDto): AnyAction {
        return {type: ActionTypes.RECEIVE_INIT_DATA, initData: dto};
    },
    DynTableReload(dynTableReload: boolean): AnyAction {
        return {type: ActionTypes.DYNTABLE_RELOAD, dynTableReload};
    },
    DynTableRollBack(dynTabelRollback: boolean): AnyAction {
        return {type: ActionTypes.DYNTABLE_ROLLBACK, dynTabelRollback};
    },
    DynTableSetSelectedIdList(idList: string[]): AnyAction {
        return {type: ActionTypes.DYNTABLE_SELECTEDIDLIST, idList};
    },
    AddTranslationLocation(translation: ILocationTranslation) {
        return {type: ActionTypes.ADD_LOCATION_TRANSLATION, translation: translation};
    },
    ResetToFactoryUserSettings() {
        return {type: ActionTypes.SET_FACTORY_USER_SETTINGS};
    },
    AddRecentDocument(appLink: IApplicationLink) {
        return {type: ActionTypes.ADD_RECENT_DOCUMENT, appLink: appLink};
    },
    AddLoadingMessage(message: string) {
        return {type: ActionTypes.ADD_LOADING_MESSAGE, message: message};
    },
    RemoveLoadingMessage(message: string) {
        return {type: ActionTypes.REMOVE_LOADING_MESSAGE, message: message};
    },
    SaveUserSettings(userSettings: IUserSettings, t: reactI18Next.TranslationFunction) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            dispatch(GeneralActions.AddLoadingMessage(t('GLOBAL:SAVING_USER_SETTINGS')));
            const {baseLinks, client, userInfo} = getState().general;

            if (!userInfo) {
                renderErrorToast({
                    message: "ERRORS:MISSING_USER_INFO",
                    timestamp: Date.now()
                }
                );
                dispatch(GeneralActions.RemoveLoadingMessage(t('GLOBAL:SAVING_USER_SETTINGS')));
                return;
            }

            if (!baseLinks || !client.PATCH_userSettings(baseLinks).canExecute()) {
                renderErrorToast({
                    message: "ERRORS:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:UPDATE_USER_SETTINGS",
                    timestamp: Date.now()
                }
                );
                dispatch(GeneralActions.RemoveLoadingMessage(t('GLOBAL:SAVING_USER_SETTINGS')));
                return;
            }

            const request = client.PATCH_userSettings(baseLinks);

            userInfo.userSettings = JSON.stringify(userSettings);
            request.execute(userInfo)
                .then((value: Link) => {

                    dispatch(GeneralActions.RemoveLoadingMessage(t('GLOBAL:SAVING_USER_SETTINGS')));
                    dispatch(GeneralActions.AddLoadingMessage(t('GLOBAL:GET_UPDATED_USER_SETTINGS')));

                    const userInfoRequest = client.GET_currentUserInfo(baseLinks);
                    if (!userInfoRequest.canExecute()) {
                        renderErrorToast({
                            message: "ERRORS:MISSING_ACCESS_RIGHTS",
                            details: "ERRORS:GET_USER_INFO",
                            timestamp: Date.now()
                        }
                        );
                        dispatch(GeneralActions.RemoveLoadingMessage(t('GLOBAL:GET_UPDATED_USER_SETTINGS')));
                        return;
                    }

                    client.GET_currentUserInfo(baseLinks).execute()
                        .then((userDto: UserDto) => {

                            dispatch(GeneralActions.RemoveLoadingMessage(t('GLOBAL:GET_UPDATED_USER_SETTINGS')));

                            // update the user info in the redux state
                            dispatch(GeneralActions.UserInfoLoaded(userDto));
                        })
                        .catch((reason) => {
                            renderErrorToast({
                                message: "ERRORS:FAILED_GET_USER_INFO",
                                details: reason,
                                timestamp: Date.now()
                            }
                            );
                            dispatch(GeneralActions.RemoveLoadingMessage(t('GLOBAL:GET_UPDATED_USER_SETTINGS')));
                        });
                })
                .catch((reason) => {
                    renderErrorToast({
                        message: "ERRORS:FAILED_UPDATE_USER_SETTINGS",
                        details: reason,
                        timestamp: Date.now()
                    }
                    );
                    dispatch(GeneralActions.RemoveLoadingMessage(t('GLOBAL:SAVING_USER_SETTINGS')));
                });

        };
    },
    SetLoadingMutex(mutexName: String, value: boolean) {
        return {type: ActionTypes.SET_LOADING_MUTEX, mutexName: mutexName, value: value};
    },
    GetWorkflows(t: reactI18Next.TranslationFunction, reload?: boolean) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            Helpers.getSomething<ResourceListOfWorkflowDto>(
                dispatch,
                getState(),
                "GET_workflows",
                "loadingWorkflows",
                (val) => Helpers.mapToFlatArray<WorkflowDto>(dispatch, val, this.ReceiveWorkflows, "Requesting workflows failed"),
                t("LOAD_WORKFLOWS"),
                "Requesting workflows failed",
                reload ? "workflows" : undefined);
        };
    },
    ReceiveWorkflows(workflowList: WorkflowDto[]): AnyAction {
        return {type: ActionTypes.RECEIVE_WORKFLOW_LIST, workflowList: workflowList};
    },
    UserInfoLoaded(userInfo: UserDto): AnyAction {
        return {type: ActionTypes.USER_INFO_LOADED, userInfo: userInfo};
    },
    ChangeLanguage(language: string) {
        return {type: ActionTypes.CHANGE_LANGUAGE, language: language};
    },
    ChangeTableHeaderMode() {
        return {type: ActionTypes.CHANGE_TABLE_MODE};
    },
    LoginAction(token: string): AnyAction {
        return {type: ActionTypes.LOGIN, token: token};
    },
    ReceivedDerivates(data?: ModeltypeBasicDto[]) {
        return {type: ActionTypes.RECEIVE_DERIVATES, data: data};
    },
    GetDerivates(t: reactI18Next.TranslationFunction, modelyear: ModelyearDto, metadata: boolean) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            Helpers.getSomethingWithLinks<ResourceListOfModeltypeBasicDto>(
                dispatch,
                getState(),
                modelyear,
                "GET_modeltypeBasicList",
                "loadingMTB",
                (val) => Helpers.mapToFlatArray<ModeltypeBasicDto>(dispatch, val, GeneralActions.ReceivedDerivates, "Requesting" +
                    " model type basic failed"),
                t("LOAD_MODELTYPE_BASIC_LIST"),
                "Requesting model type basic failed",
                undefined,
                metadata);
        };
    },
    SetKumaManagerRolePermission(isShow:boolean) {
        return {type: ActionTypes.ISKUMA_MANAGER_ROLE_ONLY, isShow};
    },
    ReceiveMaintenanceStatus(maintenanceStatus:MaintenanceListDto) {
      return {type: ActionTypes.MAINTENANCE_STATUS, maintenanceStatus};
    },
    ReceiveTranslationServiceAction(translationService: any) {
        return {type: ActionTypes.RECEIVE_TRANSLATION_SERVICE, translationService};
    }
};

export default GeneralActions;



// WEBPACK FOOTER //
// ./src/redux/actions/GeneralActions.tsx